/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { ManufactureProcessCategoryBreakdownDtoListBaseResponse } from '../models/manufacture-process-category-breakdown-dto-list-base-response';
import { ManufactureProcessCategoryListDto } from '../models/manufacture-process-category-list-dto';
import { ManufactureProcessCategoryListDtoBaseResponse } from '../models/manufacture-process-category-list-dto-base-response';
import { ManufactureProcessCategoryListDtoListBaseResponse } from '../models/manufacture-process-category-list-dto-list-base-response';
import { ManufactureProcessDto } from '../models/manufacture-process-dto';
import { ManufactureProcessDtoBaseResponse } from '../models/manufacture-process-dto-base-response';
import { ManufactureProcessDtoListBaseResponse } from '../models/manufacture-process-dto-list-base-response';
import { ManufactureProcessStageDto } from '../models/manufacture-process-stage-dto';
import { ManufactureProcessStepDto } from '../models/manufacture-process-step-dto';
import { ManufactureProcessStepDtoBaseResponse } from '../models/manufacture-process-step-dto-base-response';

@Injectable({
  providedIn: 'root',
})
export class ManufactureProcessService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiManufactureProcessGetCategoriesListGet
   */
  static readonly ApiManufactureProcessGetCategoriesListGetPath = '/api/ManufactureProcess/get-categories-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessGetCategoriesListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetCategoriesListGet$Plain$Response(params?: {
    searchTerm?: string;
    isArchived?: boolean;
  }): Observable<StrictHttpResponse<ManufactureProcessCategoryListDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessGetCategoriesListGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('isArchived', params.isArchived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessCategoryListDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessGetCategoriesListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetCategoriesListGet$Plain(params?: {
    searchTerm?: string;
    isArchived?: boolean;
  }): Observable<ManufactureProcessCategoryListDtoListBaseResponse> {

    return this.apiManufactureProcessGetCategoriesListGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessCategoryListDtoListBaseResponse>) => r.body as ManufactureProcessCategoryListDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessGetCategoriesListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetCategoriesListGet$Json$Response(params?: {
    searchTerm?: string;
    isArchived?: boolean;
  }): Observable<StrictHttpResponse<ManufactureProcessCategoryListDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessGetCategoriesListGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('isArchived', params.isArchived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessCategoryListDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessGetCategoriesListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetCategoriesListGet$Json(params?: {
    searchTerm?: string;
    isArchived?: boolean;
  }): Observable<ManufactureProcessCategoryListDtoListBaseResponse> {

    return this.apiManufactureProcessGetCategoriesListGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessCategoryListDtoListBaseResponse>) => r.body as ManufactureProcessCategoryListDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiManufactureProcessGetCategoriesBreakdownGet
   */
  static readonly ApiManufactureProcessGetCategoriesBreakdownGetPath = '/api/ManufactureProcess/get-categories-breakdown';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessGetCategoriesBreakdownGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetCategoriesBreakdownGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<ManufactureProcessCategoryBreakdownDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessGetCategoriesBreakdownGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessCategoryBreakdownDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessGetCategoriesBreakdownGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetCategoriesBreakdownGet$Plain(params?: {
  }): Observable<ManufactureProcessCategoryBreakdownDtoListBaseResponse> {

    return this.apiManufactureProcessGetCategoriesBreakdownGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessCategoryBreakdownDtoListBaseResponse>) => r.body as ManufactureProcessCategoryBreakdownDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessGetCategoriesBreakdownGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetCategoriesBreakdownGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<ManufactureProcessCategoryBreakdownDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessGetCategoriesBreakdownGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessCategoryBreakdownDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessGetCategoriesBreakdownGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetCategoriesBreakdownGet$Json(params?: {
  }): Observable<ManufactureProcessCategoryBreakdownDtoListBaseResponse> {

    return this.apiManufactureProcessGetCategoriesBreakdownGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessCategoryBreakdownDtoListBaseResponse>) => r.body as ManufactureProcessCategoryBreakdownDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiManufactureProcessGetProcessesForCategoryGet
   */
  static readonly ApiManufactureProcessGetProcessesForCategoryGetPath = '/api/ManufactureProcess/get-processes-for-category';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessGetProcessesForCategoryGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetProcessesForCategoryGet$Plain$Response(params?: {
    categoryId?: number;
  }): Observable<StrictHttpResponse<ManufactureProcessDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessGetProcessesForCategoryGetPath, 'get');
    if (params) {
      rb.query('categoryId', params.categoryId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessGetProcessesForCategoryGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetProcessesForCategoryGet$Plain(params?: {
    categoryId?: number;
  }): Observable<ManufactureProcessDtoListBaseResponse> {

    return this.apiManufactureProcessGetProcessesForCategoryGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessDtoListBaseResponse>) => r.body as ManufactureProcessDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessGetProcessesForCategoryGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetProcessesForCategoryGet$Json$Response(params?: {
    categoryId?: number;
  }): Observable<StrictHttpResponse<ManufactureProcessDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessGetProcessesForCategoryGetPath, 'get');
    if (params) {
      rb.query('categoryId', params.categoryId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessGetProcessesForCategoryGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetProcessesForCategoryGet$Json(params?: {
    categoryId?: number;
  }): Observable<ManufactureProcessDtoListBaseResponse> {

    return this.apiManufactureProcessGetProcessesForCategoryGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessDtoListBaseResponse>) => r.body as ManufactureProcessDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiManufactureProcessGetProcessGet
   */
  static readonly ApiManufactureProcessGetProcessGetPath = '/api/ManufactureProcess/get-process';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessGetProcessGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetProcessGet$Plain$Response(params?: {
    processId?: number;
  }): Observable<StrictHttpResponse<ManufactureProcessDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessGetProcessGetPath, 'get');
    if (params) {
      rb.query('processId', params.processId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessGetProcessGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetProcessGet$Plain(params?: {
    processId?: number;
  }): Observable<ManufactureProcessDtoBaseResponse> {

    return this.apiManufactureProcessGetProcessGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessDtoBaseResponse>) => r.body as ManufactureProcessDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessGetProcessGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetProcessGet$Json$Response(params?: {
    processId?: number;
  }): Observable<StrictHttpResponse<ManufactureProcessDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessGetProcessGetPath, 'get');
    if (params) {
      rb.query('processId', params.processId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessGetProcessGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessGetProcessGet$Json(params?: {
    processId?: number;
  }): Observable<ManufactureProcessDtoBaseResponse> {

    return this.apiManufactureProcessGetProcessGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessDtoBaseResponse>) => r.body as ManufactureProcessDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiManufactureProcessAddCategoryPost
   */
  static readonly ApiManufactureProcessAddCategoryPostPath = '/api/ManufactureProcess/add-category';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessAddCategoryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessAddCategoryPost$Plain$Response(params?: {
    body?: ManufactureProcessCategoryListDto
  }): Observable<StrictHttpResponse<ManufactureProcessCategoryListDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessAddCategoryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessCategoryListDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessAddCategoryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessAddCategoryPost$Plain(params?: {
    body?: ManufactureProcessCategoryListDto
  }): Observable<ManufactureProcessCategoryListDtoBaseResponse> {

    return this.apiManufactureProcessAddCategoryPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessCategoryListDtoBaseResponse>) => r.body as ManufactureProcessCategoryListDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessAddCategoryPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessAddCategoryPost$Json$Response(params?: {
    body?: ManufactureProcessCategoryListDto
  }): Observable<StrictHttpResponse<ManufactureProcessCategoryListDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessAddCategoryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessCategoryListDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessAddCategoryPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessAddCategoryPost$Json(params?: {
    body?: ManufactureProcessCategoryListDto
  }): Observable<ManufactureProcessCategoryListDtoBaseResponse> {

    return this.apiManufactureProcessAddCategoryPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessCategoryListDtoBaseResponse>) => r.body as ManufactureProcessCategoryListDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiManufactureProcessUpdateCategoryPut
   */
  static readonly ApiManufactureProcessUpdateCategoryPutPath = '/api/ManufactureProcess/update-category';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessUpdateCategoryPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateCategoryPut$Plain$Response(params?: {
    body?: ManufactureProcessCategoryListDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessUpdateCategoryPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessUpdateCategoryPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateCategoryPut$Plain(params?: {
    body?: ManufactureProcessCategoryListDto
  }): Observable<BooleanBaseResponse> {

    return this.apiManufactureProcessUpdateCategoryPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessUpdateCategoryPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateCategoryPut$Json$Response(params?: {
    body?: ManufactureProcessCategoryListDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessUpdateCategoryPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessUpdateCategoryPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateCategoryPut$Json(params?: {
    body?: ManufactureProcessCategoryListDto
  }): Observable<BooleanBaseResponse> {

    return this.apiManufactureProcessUpdateCategoryPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiManufactureProcessAddProcessPost
   */
  static readonly ApiManufactureProcessAddProcessPostPath = '/api/ManufactureProcess/add-process';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessAddProcessPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessAddProcessPost$Plain$Response(params?: {
    body?: ManufactureProcessDto
  }): Observable<StrictHttpResponse<ManufactureProcessDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessAddProcessPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessAddProcessPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessAddProcessPost$Plain(params?: {
    body?: ManufactureProcessDto
  }): Observable<ManufactureProcessDtoBaseResponse> {

    return this.apiManufactureProcessAddProcessPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessDtoBaseResponse>) => r.body as ManufactureProcessDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessAddProcessPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessAddProcessPost$Json$Response(params?: {
    body?: ManufactureProcessDto
  }): Observable<StrictHttpResponse<ManufactureProcessDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessAddProcessPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessAddProcessPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessAddProcessPost$Json(params?: {
    body?: ManufactureProcessDto
  }): Observable<ManufactureProcessDtoBaseResponse> {

    return this.apiManufactureProcessAddProcessPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessDtoBaseResponse>) => r.body as ManufactureProcessDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiManufactureProcessUpdateProcessPut
   */
  static readonly ApiManufactureProcessUpdateProcessPutPath = '/api/ManufactureProcess/update-process';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessUpdateProcessPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateProcessPut$Plain$Response(params?: {
    body?: ManufactureProcessDto
  }): Observable<StrictHttpResponse<ManufactureProcessDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessUpdateProcessPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessUpdateProcessPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateProcessPut$Plain(params?: {
    body?: ManufactureProcessDto
  }): Observable<ManufactureProcessDtoBaseResponse> {

    return this.apiManufactureProcessUpdateProcessPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessDtoBaseResponse>) => r.body as ManufactureProcessDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessUpdateProcessPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateProcessPut$Json$Response(params?: {
    body?: ManufactureProcessDto
  }): Observable<StrictHttpResponse<ManufactureProcessDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessUpdateProcessPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessUpdateProcessPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateProcessPut$Json(params?: {
    body?: ManufactureProcessDto
  }): Observable<ManufactureProcessDtoBaseResponse> {

    return this.apiManufactureProcessUpdateProcessPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessDtoBaseResponse>) => r.body as ManufactureProcessDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiManufactureProcessAddStepPost
   */
  static readonly ApiManufactureProcessAddStepPostPath = '/api/ManufactureProcess/add-step';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessAddStepPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessAddStepPost$Plain$Response(params?: {
    body?: ManufactureProcessStepDto
  }): Observable<StrictHttpResponse<ManufactureProcessStepDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessAddStepPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessStepDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessAddStepPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessAddStepPost$Plain(params?: {
    body?: ManufactureProcessStepDto
  }): Observable<ManufactureProcessStepDtoBaseResponse> {

    return this.apiManufactureProcessAddStepPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessStepDtoBaseResponse>) => r.body as ManufactureProcessStepDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessAddStepPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessAddStepPost$Json$Response(params?: {
    body?: ManufactureProcessStepDto
  }): Observable<StrictHttpResponse<ManufactureProcessStepDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessAddStepPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ManufactureProcessStepDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessAddStepPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessAddStepPost$Json(params?: {
    body?: ManufactureProcessStepDto
  }): Observable<ManufactureProcessStepDtoBaseResponse> {

    return this.apiManufactureProcessAddStepPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ManufactureProcessStepDtoBaseResponse>) => r.body as ManufactureProcessStepDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiManufactureProcessUpdateStagePut
   */
  static readonly ApiManufactureProcessUpdateStagePutPath = '/api/ManufactureProcess/update-stage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessUpdateStagePut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateStagePut$Plain$Response(params?: {
    body?: ManufactureProcessStageDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessUpdateStagePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessUpdateStagePut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateStagePut$Plain(params?: {
    body?: ManufactureProcessStageDto
  }): Observable<BooleanBaseResponse> {

    return this.apiManufactureProcessUpdateStagePut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessUpdateStagePut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateStagePut$Json$Response(params?: {
    body?: ManufactureProcessStageDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessUpdateStagePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessUpdateStagePut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateStagePut$Json(params?: {
    body?: ManufactureProcessStageDto
  }): Observable<BooleanBaseResponse> {

    return this.apiManufactureProcessUpdateStagePut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiManufactureProcessUpdateStepPut
   */
  static readonly ApiManufactureProcessUpdateStepPutPath = '/api/ManufactureProcess/update-step';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessUpdateStepPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateStepPut$Plain$Response(params?: {
    body?: ManufactureProcessStepDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessUpdateStepPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessUpdateStepPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateStepPut$Plain(params?: {
    body?: ManufactureProcessStepDto
  }): Observable<BooleanBaseResponse> {

    return this.apiManufactureProcessUpdateStepPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessUpdateStepPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateStepPut$Json$Response(params?: {
    body?: ManufactureProcessStepDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessUpdateStepPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessUpdateStepPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiManufactureProcessUpdateStepPut$Json(params?: {
    body?: ManufactureProcessStepDto
  }): Observable<BooleanBaseResponse> {

    return this.apiManufactureProcessUpdateStepPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiManufactureProcessToggleArchiveProcessDelete
   */
  static readonly ApiManufactureProcessToggleArchiveProcessDeletePath = '/api/ManufactureProcess/toggle-archive-process';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessToggleArchiveProcessDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveProcessDelete$Plain$Response(params?: {
    processId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessToggleArchiveProcessDeletePath, 'delete');
    if (params) {
      rb.query('processId', params.processId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessToggleArchiveProcessDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveProcessDelete$Plain(params?: {
    processId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiManufactureProcessToggleArchiveProcessDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessToggleArchiveProcessDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveProcessDelete$Json$Response(params?: {
    processId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessToggleArchiveProcessDeletePath, 'delete');
    if (params) {
      rb.query('processId', params.processId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessToggleArchiveProcessDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveProcessDelete$Json(params?: {
    processId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiManufactureProcessToggleArchiveProcessDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiManufactureProcessToggleArchiveCategoryDelete
   */
  static readonly ApiManufactureProcessToggleArchiveCategoryDeletePath = '/api/ManufactureProcess/toggle-archive-category';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessToggleArchiveCategoryDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveCategoryDelete$Plain$Response(params?: {
    categoryId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessToggleArchiveCategoryDeletePath, 'delete');
    if (params) {
      rb.query('categoryId', params.categoryId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessToggleArchiveCategoryDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveCategoryDelete$Plain(params?: {
    categoryId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiManufactureProcessToggleArchiveCategoryDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessToggleArchiveCategoryDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveCategoryDelete$Json$Response(params?: {
    categoryId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessToggleArchiveCategoryDeletePath, 'delete');
    if (params) {
      rb.query('categoryId', params.categoryId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessToggleArchiveCategoryDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveCategoryDelete$Json(params?: {
    categoryId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiManufactureProcessToggleArchiveCategoryDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiManufactureProcessToggleArchiveStageDelete
   */
  static readonly ApiManufactureProcessToggleArchiveStageDeletePath = '/api/ManufactureProcess/toggle-archive-stage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessToggleArchiveStageDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveStageDelete$Plain$Response(params?: {
    stageId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessToggleArchiveStageDeletePath, 'delete');
    if (params) {
      rb.query('stageId', params.stageId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessToggleArchiveStageDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveStageDelete$Plain(params?: {
    stageId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiManufactureProcessToggleArchiveStageDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessToggleArchiveStageDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveStageDelete$Json$Response(params?: {
    stageId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessToggleArchiveStageDeletePath, 'delete');
    if (params) {
      rb.query('stageId', params.stageId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessToggleArchiveStageDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveStageDelete$Json(params?: {
    stageId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiManufactureProcessToggleArchiveStageDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiManufactureProcessToggleArchiveStepDelete
   */
  static readonly ApiManufactureProcessToggleArchiveStepDeletePath = '/api/ManufactureProcess/toggle-archive-step';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessToggleArchiveStepDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveStepDelete$Plain$Response(params?: {
    stepId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessToggleArchiveStepDeletePath, 'delete');
    if (params) {
      rb.query('stepId', params.stepId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessToggleArchiveStepDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveStepDelete$Plain(params?: {
    stepId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiManufactureProcessToggleArchiveStepDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiManufactureProcessToggleArchiveStepDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveStepDelete$Json$Response(params?: {
    stepId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ManufactureProcessService.ApiManufactureProcessToggleArchiveStepDeletePath, 'delete');
    if (params) {
      rb.query('stepId', params.stepId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiManufactureProcessToggleArchiveStepDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiManufactureProcessToggleArchiveStepDelete$Json(params?: {
    stepId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiManufactureProcessToggleArchiveStepDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

}
